import React, { useState, useEffect } from "react";

const HeroSection = ({ featuredProducts }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (!featuredProducts || !Array.isArray(featuredProducts) || featuredProducts.length === 0) {
      return;
    }
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredProducts.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [featuredProducts]);

  if (!featuredProducts || !Array.isArray(featuredProducts) || !featuredProducts.length) return null;

  return (
    <div className="relative h-96 md:h-[500px] bg-gradient-to-r from-pink-50 to-purple-50 overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center z-10">
          <img 
            src="/images/logos/Monvi_Styles_Brand_Identity_Design-removebg-preview (1).png" 
            alt="Monvi Styles" 
            className="h-24 md:h-32 w-auto mx-auto mb-6"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">
            Discover MONVI
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-8">
            Elegant ethnic wear for every occasion
          </p>
          <button className="bg-pink-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-pink-700 transition-colors">
            Shop Now
          </button>
        </div>
      </div>
      
      {/* Background Images */}
      <div className="absolute inset-0 opacity-20">
        <img 
          src={featuredProducts[currentSlide]?.images?.[0] || '/images/placeholder.jpg'} 
          alt="Hero" 
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = '/images/placeholder.jpg';
          }}
        />
      </div>
      
      {/* Slide indicators */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {featuredProducts && featuredProducts.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full transition-colors ${
              index === currentSlide ? 'bg-pink-600' : 'bg-gray-300'
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSection;
